export const PulseOpacitySpinner = () => {
  return (
    <div className=" d-flex align-items-center justify-content-center">
      <img src={process.env.PUBLIC_URL + '/bola.png'} alt="Municipalidad Spinner Pulse" className="pulse-spinner" style={{height: '200px', width: '200px'}} />
    </div>
  )
}

export default PulseOpacitySpinner